import React from 'react';
import { connect } from 'react-redux';
import P from '@leverege/promise';
import { DataSources, Attributes } from '@leverege/ui-attributes';
import { GroupActions } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import { Blocker } from '@leverege/molten/views';
import { Pane, Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export const STATUSES = {
  paid: 'Paid',
  partiallyPaid: 'Partially Paid',
  notPaid: 'Not Paid',
  overpaid: 'Overpaid',
  notApplicable: 'Not Applicable'
};
const VARIANTS = {
  [STATUSES.paid]: 'pillSuccess',
  [STATUSES.partiallyPaid]: 'pillWarning',
  [STATUSES.notPaid]: 'pillError',
  [STATUSES.overpaid]: 'pillWarning',
  [STATUSES.notApplicable]: 'pill',
  '--': null
};
class PaymentStatusRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
  }
  componentDidMount() {
    this._isMounted = true;
    const {
      paymentActions,
      addendumChargeActions,
      addendumCreditActions
    } = this.props;
    Promise.all([GlobalState.dispatch(paymentActions.search({
      limit: 0,
      aggs: {
        payments: {
          type: 'stats',
          field: 'data/amount'
        }
      }
    }, {
      ttl: 30000
    })), GlobalState.dispatch(addendumChargeActions.search({
      limit: 0,
      aggs: {
        charges: {
          type: 'stats',
          field: 'data/amount'
        }
      },
      filter: {
        field: 'data/type',
        type: 'equals',
        value: 'charge'
      }
    }, {
      ttl: 30000
    })), GlobalState.dispatch(addendumCreditActions.search({
      limit: 0,
      aggs: {
        credits: {
          type: 'stats',
          field: 'data/amount'
        }
      },
      filter: {
        field: 'data/type',
        type: 'equals',
        value: 'credit'
      }
    }, {
      ttl: 30000
    })), GlobalState.dispatch(paymentActions.search({
      limit: 0,
      aggs: {
        payments: {
          type: 'stats',
          field: 'data/amount'
        }
      }
    }, {
      ttl: 30000
    }))]).then(res => {
      if (this._isMounted) {
        this.initialLoad.resolve();
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  getStatus(due, paid, year) {
    // Before 2022 payments were not implemented
    if (year < 2022) {
      return STATUSES.notApplicable;
    }
    if (due === 0) {
      return STATUSES.paid;
    }
    if (due > 0) {
      if (paid > 0) {
        return STATUSES.partiallyPaid;
      }
      return STATUSES.notPaid;
    }
    if (due < 0) {
      return STATUSES.overpaid;
    }
    return '--';
  }
  renderChildren = () => {
    const {
      aggs,
      original,
      addendumChargeAggs,
      addendumCreditAggs
    } = this.props;
    const paymentSum = aggs?.payments?.sum || 0;
    const addendumChargeAmount = addendumChargeAggs?.charges?.sum || 0;
    const addendumCreditAmount = addendumCreditAggs?.credits?.sum || 0;
    const totalBill = (Attributes.get('bill.totalBill', 'bill', original.data) || 0) + addendumChargeAmount;
    const due = totalBill - paymentSum - addendumCreditAmount;
    const year = Attributes.get('bill.year', 'bill', original.data);
    const status = this.getStatus(due, paymentSum, year);
    const variant = VARIANTS[status];
    return /*#__PURE__*/_jsx(Pane, {
      variant: "tableCellContent",
      children: /*#__PURE__*/_jsx(Text, {
        variant: variant,
        children: status
      })
    });
  };
  render() {
    const matchContext = {
      client: 'TotalPaidRenderer'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, ownProps) => {
  const {
    original
  } = ownProps;
  const billActions = DataSources.getActions(original);
  const childActions = billActions.child('payments');
  const paymentActions = new GroupActions({
    match: childActions.match,
    relationship: childActions.relationship,
    queryName: 'totalPaymentsAgg'
  });
  const addendumChildActions = billActions.child('addendum');
  const addendumChargeActions = new GroupActions({
    match: addendumChildActions.match,
    relationship: addendumChildActions.relationship,
    queryName: 'totalAddendumChargesAgg'
  });
  const addendumCreditActions = new GroupActions({
    match: addendumChildActions.match,
    relationship: addendumChildActions.relationship,
    queryName: 'totalAddendumCreditsAgg'
  });
  const aggs = paymentActions.getList(state, {
    getAll: true
  })?.aggs;
  const addendumChargeAggs = addendumChargeActions.getList(state, {
    getAll: true
  })?.aggs;
  const addendumCreditAggs = addendumCreditActions.getList(state, {
    getAll: true
  })?.aggs;
  return {
    models: state.models,
    paymentActions,
    aggs,
    addendumChargeActions,
    addendumCreditActions,
    addendumChargeAggs,
    addendumCreditAggs
  };
})(PaymentStatusRenderer);